import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
  Form,
  InputGroup,
} from "react-bootstrap";
import Select from "react-select";
import Card from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
import {
  getb2b,
  getPackage,
  searchSpeciality,
  getInsuredUsers,
  updatePackage,
  gettagstearwise,
  getcouponstagwise,
  addNewPackage,
} from "../../../Listfunction";
import InputColor from "react-input-color";
import Radio from "components/CustomRadio/CustomRadio.jsx";
import { getApiErrorMessage } from "utils/getApiErrorMessage";

class editProductCatalogue extends Component {
  constructor(props) {
    super(props);
    this.state = {
      package_description: "",
      package_name: "",
      package_nameError: null,
      package_duration: "",
      free_trial: "",
      package_durationError: null,
      package_price: "",
      package_priceError: null,
      feature_chkError: null,
      n_o_calls: "",
      n_o_callsError: null,
      raya_discount: "",
      raya_discountError: null,
      lab_discount: "",
      lab_discountError: null,
      express_order: "",
      express_orderError: null,
      medicin_discount: "",
      medicin_discountError: null,
      cardHidden: true,
      processing: true,
      feature_chk: [],
      background_color: "",
      user_type: "1",
      duration_type: "1",
      free_trial_type: "1",
      is_featured: "0",
      doctorspecialityItems: [],
      insurance_item: [],
      specialityList: [],
      insurance_details: [],
      insurance_data: [],
      address_line_1: "",
      address_line_2: "",
      discounted_price: "",
      addresslist: [
        {
          srno: 1,
          address_line_1: "",
          address_line_2: "",
        },
      ],
      tagList: [],
      tagListOption: [],
      couponList: [],
      coupon_id: [],
      couponTitleId: [],

      feature_chk_data: [
        {
          id: 6,
          chk_value: 6,
          label: "Medicine",
          checked: false,
          placeholder: "Enter Discount",
          name: "medicine_discount",
          input_value: "",
          errorMessage: "Medicine discount is required.",
        },
        {
          id: 3,
          chk_value: 3,
          label: "Lab",
          checked: false,
          placeholder: "Enter Discount",
          name: "lab_discount",
          input_value: "",
          errorMessage: "Lab Discount is required.",
        },
        {
          id: 2,
          chk_value: 2,
          label: "Raya",
          checked: false,
          placeholder: "Enter Discount",
          name: "raya_flat_discount",
          input_value: "",
          errorMessage: "Raya Discount is required.",
        },
        {
          id: 1,
          chk_value: 1,
          label: "Talk now",
          checked: false,
          placeholder: "Talk now",
          name: "no_of_calls",
          input_value: "",
          errorMessage: "Talk now is required.",
          unlimited: false,
        },
        {
          id: 8,
          chk_value: 8,
          label: "Talk later",
          checked: false,
          placeholder: "Talk later",
          name: "no_of_calls_talk_later",
          input_value: [],
          errorMessage: "Talk later is required.",
        },
        {
          id: 4,
          chk_value: 4,
          label: "MBE",
          checked: false,
          placeholder: "MBE Price",
          name: "mbe_price",
          input_value: "",
          errorMessage: "MBE Price is required.",
        },
        {
          id: 5,
          chk_value: 5,
          label: "Express",
          checked: false,
          placeholder: "N.O Express order",
          name: "no_of_express_order",
          input_value: "",
          errorMessage: "N.O Express order is required.",
        },
        {
          id: 7,
          chk_value: 7,
          label: "Insurance",
          checked: false,
          placeholder: "N.O Insurance",
          name: "no_of_insurance_order",
          input_value: "",
          insurance_key_value: [],
          insurance_id: [],
          errorMessage: "N.O Insurance order is required.",
        },
        {
          id: 9,
          chk_value: 9,
          label: "PCM",
          checked: false,
          placeholder: "Partner & Coupon Management",
          name: "partner_and_coupon_management",
          input_value: "",
          value: [],
          errorMessage: "Partner & Coupon Management is required.",
        },
      ],
    };
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
  }

  userType = [
    { value: 1, label: "B2B" },
    { value: 2, label: "B2C" },
    { value: 3, label: "B2B2C" },
  ];

  duration_type = [
    { value: 1, label: "Days" },
    { value: 2, label: "Week" },
    { value: 3, label: "Month" },
    { value: 4, label: "Year" },
  ];

  free_trial_type = [
    { value: 1, label: "Days" },
    { value: 2, label: "Week" },
    { value: 3, label: "Month" },
    { value: 4, label: "Year" },
  ];

  async componentDidMount() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    var id = JSON.parse(localStorage.getItem("packageId"));

    searchSpeciality(obj).then((response) => {
      const mdata = response.data;
      var activespeciality = [];
      for (let i = 0; i < mdata.length; i++) {
        if (mdata[i].is_active == 1) {
          activespeciality.push(mdata[i]);
        }
      }

      let pcItems = [];
      activespeciality.map((x, i) => {
        pcItems.push({ value: x.id, label: x.title });
      });

      this.setState({
        doctorspecialityItems: pcItems,
        specialityList: activespeciality,
      });
    });

    let riderItems = [];
    getInsuredUsers(obj).then((res) => {
      const data = res.data;
      data.data.map((x, i) => {
        riderItems.push({ value: x.id, label: x.name });
      });
      this.setState({
        insuranceUsers: riderItems,
      });
    });

    setTimeout(async () => {
      await getPackage(id, obj).then((response) => {
        var packageData = response.data.data;
        var p_feature = response.data.data.packageFeatures;
        let list = [...this.state.feature_chk_data];

        this.setState({
          package_name: packageData.title,
          package_duration: packageData.duration,
          package_price: packageData.price,
          package_description: packageData.description,
          duration_type: packageData.duration_type,
          background_color: packageData.background_color,
          user_type: packageData.user_type,
          free_trial: packageData.free_trial,
          free_trial_type: packageData.free_trial_type,
          discounted_price: packageData.discounted_price,
          is_featured: JSON.stringify(packageData.is_featured),
        });

        // Sort Object With category_id
        p_feature.sort((a, b) => (a.category_id > b.category_id ? 1 : -1));
        for (let i = 0; i < list.length; i++) {
          for (let j = 0; j < p_feature.length; j++) {
            if (list[i].chk_value == p_feature[j].category_id) {
              if (p_feature[j].value) {
                if (p_feature[j].category_id == "8") {
                  var pcvalue = [];
                  if (p_feature[j].value.length > 0) {
                    for (let xi = 0; xi < p_feature[j].value.length; xi++) {
                      console.log();
                      var opt_value = "";
                      for (
                        let xy = 0;
                        xy < this.state.doctorspecialityItems.length;
                        xy++
                      ) {
                        if (
                          this.state.doctorspecialityItems[xy].value ==
                          p_feature[j].value[xi].speciality_id
                        ) {
                          opt_value = this.state.doctorspecialityItems[xy];
                          break;
                        }
                      }
                      var details = {
                        specility: opt_value,
                        no_of_calls: p_feature[j].value
                          ? p_feature[j].value[xi].no_of_calls
                          : "",
                      };
                      pcvalue.push(details);
                    }
                    list[i]["input_value"] = pcvalue;
                    list[i]["checked"] = true;
                  }
                } else if (p_feature[j].category_id == "9") {
                  var pcvalue = [];
                  if (p_feature[j].coupons.length > 0) {
                    for (let xi = 0; xi < p_feature[j].coupons.length; xi++) {
                      var data_ins = {
                        id: p_feature[j].coupons
                          ? p_feature[j].coupons[xi].id
                          : "",
                        title: p_feature[j].coupons
                          ? p_feature[j].coupons[xi].title
                          : "",
                      };
                      pcvalue.push(data_ins);
                    }
                    list[i]["value"] = pcvalue;
                    list[i]["checked"] = true;

                    pcvalue.map((a, b) => this.state.coupon_id.push(a.id));
                  }
                } else if (p_feature[j].category_id == "7") {
                  var pcvalue = [];
                  if (p_feature[j].insurance_data.length > 0) {
                    for (
                      let xi = 0;
                      xi < p_feature[j].insurance_data.length;
                      xi++
                    ) {
                      var data_ins = {
                        address_line_1: p_feature[j].insurance_data
                          ? p_feature[j].insurance_data[xi].insurance_key
                          : "",
                        address_line_2: p_feature[j].insurance_data
                          ? p_feature[j].insurance_data[xi].insurance_value
                          : "",
                      };
                      pcvalue.push(data_ins);
                    }
                    list[i]["insurance_key_value"] = pcvalue;
                    list[i]["checked"] = true;
                  }
                  if (p_feature[j].insurance_id) {
                    const insuranceUserOption = riderItems.filter(
                      (item) =>
                        item.value === parseInt(p_feature[j].insurance_id)
                    );
                    if (!!insuranceUserOption.length) {
                      list[i]["input_value"] = insuranceUserOption[0];
                    }
                  }
                } else {
                  if (
                    p_feature[j].category_id == "1" &&
                    p_feature[j].value == "unlimited"
                  ) {
                    list[i]["unlimited"] = true;
                  }
                  list[i]["input_value"] = p_feature[j].value;
                  list[i]["checked"] = true;
                }
                this.setState({ feature_chk_data: list });
              }
            }
          }
        }

        this.setState({ feature_chk: list, cardHidden: false });
      });
    }, 700);

    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  handleAllChecked_noc = (e, i) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["checked"] = checked;

    if (checked == false) {
      list[i]["input_value"] = [];
      list[i]["unlimited"] = false;
    }

    this.setState({ feature_chk: list });
  };

  handleAllChecked_noi = (e, i) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["checked"] = checked;

    if (checked == false) {
      list[i]["insurance_key_value"] = [];
      list[i]["unlimited"] = false;
    }

    this.setState({ feature_chk: list });
  };

  onChange = (e, i) => {
    const target = e.target;
    const value = target.value;
    const re = /^\d*\.?\d*$/;

    if (re.test(value) == true) {
      var list = [...this.state.feature_chk_data];
      list[i]["input_value"] = value;
      this.setState({ feature_chk: list });
    }
  };

  onSpecialityChange = (value, i, idx) => {
    var list = [...this.state.feature_chk_data];
    var arr_val = list[i]["input_value"];
    arr_val[idx].specility = value;
    list[i]["input_value"] = arr_val;
    this.setState({ feature_chk: list });
  };

  onInsuranceChange = (value, i, q) => {
    var list = [...this.state.feature_chk_data];
    list[i]["input_value"] = value;
    this.setState({ feature_chk: list });
  };

  onCallChange = (e, i, idx) => {
    const re = /^\d*$/;

    if (re.test(e.target.value) == true) {
      var list = [...this.state.feature_chk_data];
      var arr_val = list[i]["input_value"];
      arr_val[idx].no_of_calls = e.target.value;
      list[i]["input_value"] = arr_val;
      this.setState({ feature_chk: list });
    }
  };
  handleInputChangeAddresslist1 = (e, i, y) => {
    var list = [...this.state.feature_chk_data];
    var arr_val = list[i]["insurance_key_value"];
    arr_val[y].address_line_1 = e.target.value;
    list[i]["insurance_key_value"] = arr_val;
    this.setState({ feature_chk: list });
  };
  handleInputChangeAddresslist2 = (e, i, y) => {
    var list = [...this.state.feature_chk_data];
    var arr_val = list[i]["insurance_key_value"];
    arr_val[y].address_line_2 = e.target.value;
    list[i]["insurance_key_value"] = arr_val;
    this.setState({ feature_chk: list });
  };

  onNOCallAdd = (i) => {
    var list = [...this.state.feature_chk_data];
    var arr_val = list[i]["input_value"];
    arr_val.push({
      specility: "",
      no_of_calls: "",
    });
    list[i]["input_value"] = arr_val;
    this.setState({ feature_chk: list });
  };

  onNOCallRemove = (i, idx) => {
    var list = [...this.state.feature_chk_data];
    var arr_val = list[i]["input_value"];
    arr_val.splice(idx, 1);
    list[i]["input_value"] = arr_val;
    this.setState({ feature_chk: list });
  };

  onInsuranceRemove = (i, x) => {
    var list = [...this.state.feature_chk_data];
    var arr_val = list[i]["insurance_key_value"];
    arr_val.splice(x, 1);
    list[i]["insurance_key_value"] = arr_val;
    this.setState({ feature_chk: list });
  };

  handleAllChecked = (e, i) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["checked"] = checked;
    if (checked == false) {
      list[i]["input_value"] = "";
    }
    this.setState({ feature_chk: list });
  };

  onNOCallAdd_test = (i) => {
    var list = [...this.state.feature_chk_data];
    var arr_val = list[i]["insurance_key_value"];
    arr_val.push({
      address_line_1: "",
      address_line_2: "",
    });
    list[i]["insurance_key_value"] = arr_val;
    this.setState({ feature_chk: list });
  };

  onChange_tier = async (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({ tiers: value });

    await gettagstearwise(value, obj).then((res) => {
      const data = res.data;
      const tagoptions = data.tags.map((x, i) => {
        return {
          value: x,
          label: x,
        };
      });
      var current = this.state.tagListOption;
      current[value] = tagoptions;
      this.setState({ tagListOption: current });
    });
  };

  onChange_tags = async (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    var token = JSON.parse(localStorage.getItem("user"));
    const userToken = token.token;
    this.setState({ tags: value });

    const tiers = this.state.tiers;
    await getcouponstagwise(value, tiers, userToken).then((res) => {
      const data = res.data;
      const coupunoptions = data.coupons.map((x, i) => {
        return {
          id: x.id,
          title: x.title,
        };
      });

      this.setState({ couponList: coupunoptions });
    });
  };

  onChange_coupons = async (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    var token = JSON.parse(localStorage.getItem("user"));
    const userToken = token.token;
    const couponSelect = this.state.couponList.filter(
      (item) => item.id === parseInt(value)
    );
    const featureCheckData = this.state.feature_chk_data.map((item) => {
      if (item.id === 9) {
        return {
          ...item,
          value: [...item.value, couponSelect[0]],
        };
      }
      return item;
    });
    this.state.coupon_id.push(value);
    this.setState({
      feature_chk_data: featureCheckData,
      couponList: [],
      tagListOption: [],
    });
  };

  onRemove_coupon(i, indexs) {
    var list = [...this.state.feature_chk_data];
    var arr_val = list[i]["value"];
    arr_val.splice(indexs, 1);
    list[i]["value"] = arr_val;
    this.setState({ feature_chk: list });

    this.state.coupon_id.splice(indexs, 1);
    var remove_cpn = this.state.coupon_id;
    this.setState({ coupon_id: remove_cpn });
  }

  onSubmit = () => {
    let error = false;
    if (this.state.package_name.length == 0) {
      error = true;
      this.setState({
        package_nameError: (
          <small className="text-danger">Package Name is required.</small>
        ),
      });
    } else {
      this.setState({ package_nameError: null });
    }

    if (this.state.package_duration.length == 0) {
      error = true;
      this.setState({
        package_durationError: (
          <small className="text-danger">Duration is required.</small>
        ),
      });
    } else {
      this.setState({ package_durationError: null });
    }

    if (this.state.package_price.length == 0) {
      error = true;
      this.setState({
        package_priceError: (
          <small className="text-danger">Price is required.</small>
        ),
      });
    } else {
      this.setState({ package_priceError: null });
    }

    if (this.state.feature_chk.length == 0) {
      error = true;
      this.setState({
        feature_chkError: (
          <small className="text-danger">Feature is required.</small>
        ),
      });
    } else {
      this.setState({ feature_chkError: null });
    }

    if (!error) {
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;

      var id = JSON.parse(localStorage.getItem("packageId"));

      const featureArr = this.state.feature_chk;
      const featureData = [];

      featureArr.map((s, i) => {
        if (s.name == "no_of_calls_talk_later") {
          var pcvalue = [];
          for (let xi = 0; xi < s.input_value.length; xi++) {
            var speid = s.input_value[xi].specility
              ? s.input_value[xi].specility.value
              : "";
            pcvalue.push({
              speciality_id: speid,
              no_of_calls: s.input_value[xi].no_of_calls,
            });
          }

          featureData.push({
            category_id: s.chk_value,
            title: s.name,
            value: pcvalue,
          });
        } else if (s.name == "partner_and_coupon_management") {
          const cpn_id = this.state.coupon_id;
          featureData.push({
            category_id: s.chk_value,
            title: s.name,
            value: cpn_id,
          });
        } else {
          featureData.push({
            category_id: s.chk_value,
            title: s.name,
            value: s.input_value,
          });
        }
      });

      let insuranceData = [];
      this.state.feature_chk_data["7"]["insurance_key_value"].map((x, i) => {
        insuranceData.push({
          insurance_key: x.address_line_1,
          insurance_value: x.address_line_2,
        });
      });

      var user_type_p = parseInt(this.state.user_type);
      var insurance =
        this.state.feature_chk_data["7"]["input_value"] != undefined
          ? this.state.feature_chk_data["7"]["input_value"].value
          : null;
      addNewPackage(
        this.state.package_name,
        this.state.package_duration,
        this.state.duration_type,
        this.state.package_description,
        this.state.package_price,
        this.state.background_color,
        featureData,
        user_type_p,
        insurance,
        insuranceData,
        this.state.is_featured,
        this.state.free_trial_type,
        this.state.free_trial,
        this.state.discounted_price,
        obj
      )
        .then((res) => {
          if (res.data.success === true) {
            this.handleSuccess("bl");
          }
        })
        .catch((error) => {
          console.log(error, "== error");
          this.handleNetworkError("bl", error);
        });
    }
  };

  handleSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Catalogue Package</b> - Replicated Successfully.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
    setTimeout(() => {
      this.props.history.push("/admin/productcatalogue");
    }, 3000);
  }

  handleNetworkError(position, error) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          {getApiErrorMessage(error)}
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  setColor = (colors) => {
    this.setState({
      background_color: colors.hex,
    });
  };

  onnumricfieldChange(e) {
    const { value } = e.target;
    const re = /^[0-9]*$/;

    if (e.target.name == "package_price") {
      if (re.test(value) == true) {
        this.setState({ package_price: value });

        if (value == "") {
          this.setState({
            package_priceError: (
              <small className="text-danger">Price is required.</small>
            ),
          });
        } else {
          this.setState({ package_priceError: null });
        }
      }
    }

    if (e.target.name == "discounted_price") {
      if (re.test(value) == true) {
        this.setState({ discounted_price: value });
      }
    }

    if (e.target.name == "package_duration") {
      if (re.test(value) == true) {
        this.setState({ package_duration: value });

        if (value == "") {
          this.setState({
            package_durationError: (
              <small className="text-danger">Duration is required.</small>
            ),
          });
        } else {
          this.setState({ package_durationError: null });
        }
      }
    }
  }

  handleUnlimitedMbe = (e, i) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["unlimited"] = checked;
    if (checked == true) {
      list[i]["input_value"] = "unlimited";
      list[i]["checked"] = true;
    } else {
      list[i]["input_value"] = "";
    }

    this.setState({ feature_chk: list });
  };

  onChangeShowMobileApp = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;

    this.setState({
      is_featured: value,
    });
  };

  render() {
    return (
      <div className="main-content">
        <Grid fluid>
          <NotificationSystem ref="notificationSystem" style={style} />
          <Row>
            <Col md={6}>
              <Card
                content={
                  <form>
                    <Row>
                      <Col md={12}>
                        <FormGroup>
                          <ControlLabel>Type</ControlLabel>
                          <select
                            className="react-select primary form-control"
                            name="user_type"
                            value={this.state.user_type}
                            onChange={(event) => {
                              this.setState({ user_type: event.target.value });
                            }}
                          >
                            {this.userType.map((ut, idx) => (
                              <option key={idx} value={ut.value}>
                                {ut.label}
                              </option>
                            ))}
                          </select>
                        </FormGroup>
                        {this.state.user_type == 2 ? (
                          <FormGroup>
                            <ControlLabel>Show in mobile app</ControlLabel>

                            <div className="order_source_data">
                              <Radio
                                // style={{'display':'inline-block'}}
                                number="600"
                                option="1"
                                name="show_mobile_app"
                                onChange={this.onChangeShowMobileApp}
                                checked={this.state.is_featured === "1"}
                                label="Yes"
                              />
                              &nbsp;
                              <Radio
                                // style={{'display':'inline-block'}}
                                number="601"
                                option="0"
                                name="show_mobile_app"
                                onChange={this.onChangeShowMobileApp}
                                checked={this.state.is_featured === "0"}
                                label="No"
                              />
                            </div>
                          </FormGroup>
                        ) : null}
                        <FormGroup>
                          <ControlLabel>Package Name</ControlLabel>
                          <FormControl
                            name="package_name"
                            // value={this.state.package_name}
                            onChange={(event) => {
                              this.setState({
                                package_name: event.target.value,
                              });
                              event.target.value === ""
                                ? this.setState({
                                    package_nameError: (
                                      <small className="text-danger">
                                        Package name is required.
                                      </small>
                                    ),
                                  })
                                : this.setState({ package_nameError: null });
                            }}
                            placeholder="Enter Package Name"
                            type="text"
                          />
                          {this.state.package_nameError}
                        </FormGroup>

                        <FormGroup>
                          <ControlLabel>Package Description</ControlLabel>
                          <FormControl
                            name="package_description"
                            value={this.state.package_description}
                            onChange={(event) => {
                              this.setState({
                                package_description: event.target.value,
                              });
                            }}
                            placeholder="Enter Package Description"
                            type="text"
                          />
                        </FormGroup>

                        <FormGroup>
                          <ControlLabel>Free Trail</ControlLabel>
                          <Row>
                            <Col sm={6}>
                              <select
                                className="react-select primary form-control durationselect_package"
                                name="free_trial_type"
                                value={this.state.free_trial_type}
                                onChange={(event) => {
                                  this.setState({
                                    free_trial_type: event.target.value,
                                  });
                                }}
                              >
                                {this.free_trial_type.map((ut, idx) => (
                                  <option key={idx} value={ut.value}>
                                    {ut.label}
                                  </option>
                                ))}
                              </select>
                            </Col>
                            <Col sm={6}>
                              <FormControl
                                name="free_trial"
                                value={this.state.free_trial}
                                onChange={(event) => {
                                  this.setState({
                                    free_trial: event.target.value,
                                  });
                                }}
                                placeholder="Enter Package Free Trail"
                                type="text"
                              />
                            </Col>
                          </Row>
                        </FormGroup>

                        <FormGroup>
                          <ControlLabel>Package Duration</ControlLabel>
                          <Row>
                            <Col sm={6}>
                              <FormControl
                                name="package_duration"
                                value={this.state.package_duration}
                                onChange={(event) =>
                                  this.onnumricfieldChange(event)
                                }
                                placeholder="Enter Package Duration"
                                type="text"
                              />
                              {this.state.package_durationError}
                            </Col>
                            <Col sm={6}>
                              <select
                                className="react-select primary form-control durationselect_package"
                                name="duration_type"
                                value={this.state.duration_type}
                                onChange={(event) => {
                                  this.setState({
                                    duration_type: event.target.value,
                                  });
                                }}
                              >
                                {this.duration_type.map((ut, idx) => (
                                  <option key={idx} value={ut.value}>
                                    {ut.label}
                                  </option>
                                ))}
                              </select>
                            </Col>
                          </Row>
                        </FormGroup>

                        <Row>
                          <FormGroup>
                            <Col sm={6}>
                              <ControlLabel>Package Price</ControlLabel>
                              <FormControl
                                name="package_price"
                                value={this.state.package_price}
                                onChange={(event) =>
                                  this.onnumricfieldChange(event)
                                }
                                placeholder="Enter Package Price"
                                type="text"
                              />
                              {this.state.package_priceError}
                            </Col>

                            <Col sm={6}>
                              <ControlLabel>Discount</ControlLabel>

                              <FormControl
                                name="discounted_price"
                                value={this.state.discounted_price}
                                onChange={(event) =>
                                  this.onnumricfieldChange(event)
                                }
                                placeholder="Enter Discount Price"
                                type="text"
                              />
                            </Col>
                          </FormGroup>
                        </Row>

                        <FormGroup className="backgroundcolorinput">
                          <ControlLabel>Background Color</ControlLabel>
                          <InputColor
                            initialValue={this.state.background_color}
                            onChange={this.setColor}
                            placement="right"
                          />
                        </FormGroup>
                        <FormGroup>
                          <ControlLabel>Package Features</ControlLabel>
                          <div className="grp-feature">
                            {this.state.feature_chk_data.map((s, i) => (
                              <React.Fragment key={i}>
                                {s.label == "Talk later" ? (
                                  <>
                                    <Checkbox
                                      number={s.id}
                                      key={i}
                                      checked={s.checked}
                                      onChange={(e) =>
                                        this.handleAllChecked_noc(e, i)
                                      }
                                      label={s.label}
                                      value={s.chk_value}
                                    />
                                    <div className="productcat-select">
                                      <Button
                                        disabled={
                                          s.checked == true ? false : true
                                        }
                                        style={{ marginTop: 4 }}
                                        onClick={() => this.onNOCallAdd(i)}
                                      >
                                        Add
                                      </Button>
                                      <div className="pct_flaxcontainer">
                                        {s.input_value.length > 0 &&
                                          s.input_value.map((pccl, idx) => (
                                            <div className="productcat_callcontainer">
                                              <Select
                                                className="pcat_callselect"
                                                placeholder="Speciality"
                                                closeMenuOnSelect={true}
                                                value={pccl.specility}
                                                onChange={(value) =>
                                                  this.onSpecialityChange(
                                                    value,
                                                    i,
                                                    idx
                                                  )
                                                }
                                                options={
                                                  this.state
                                                    .doctorspecialityItems
                                                }
                                              />
                                              <FormControl
                                                value={pccl.no_of_calls}
                                                placeholder="Number of Calls"
                                                name={s.name}
                                                type="text"
                                                onChange={(e) =>
                                                  this.onCallChange(e, i, idx)
                                                }
                                              />
                                              <Button
                                                onClick={() =>
                                                  this.onNOCallRemove(i, idx)
                                                }
                                              >
                                                x
                                              </Button>
                                            </div>
                                          ))}
                                      </div>
                                    </div>
                                  </>
                                ) : s.label == "Talk now" ? (
                                  <>
                                    <Checkbox
                                      number={s.id}
                                      key={i}
                                      checked={s.checked}
                                      onChange={(e) =>
                                        this.handleAllChecked_noc(e, i)
                                      }
                                      label={s.label}
                                      value={s.chk_value}
                                    />
                                    <div
                                      className="mbe_ulmt_show_cont"
                                      style={{ display: "inline-flex" }}
                                    >
                                      <FormControl
                                        style={{ width: "inherit" }}
                                        disabled={
                                          s.checked == true ? false : true
                                        }
                                        value={s.input_value}
                                        placeholder={s.placeholder}
                                        name={s.name}
                                        type="text"
                                        onChange={(e) => this.onChange(e, i)}
                                      />
                                      <Checkbox
                                        number={s.id + 100}
                                        key={i + 100}
                                        checked={s.unlimited}
                                        onChange={(e) =>
                                          this.handleUnlimitedMbe(e, i)
                                        }
                                        label="Unlimited"
                                        value={s.unlimited}
                                      />
                                    </div>
                                  </>
                                ) : s.label == "Insurance" ? (
                                  <>
                                    <div
                                      className="mbe_ulmt_show_cont"
                                      style={{ display: "inline-flex" }}
                                    >
                                      <Checkbox
                                        number={s.id}
                                        key={i}
                                        checked={s.checked}
                                        onChange={(e) =>
                                          this.handleAllChecked_noi(e, i)
                                        }
                                        label={s.label}
                                        value={s.chk_value}
                                      />

                                      <div className="productcat-select">
                                        <Select
                                          isDisabled={!s.checked}
                                          style={{ width: "100%" }}
                                          className="react-select primary insurance-dropdown"
                                          classNamePrefix="react-select"
                                          placeholder="Insurance"
                                          name="insurance_id"
                                          value={s.input_value}
                                          onChange={(value) =>
                                            this.onInsuranceChange(value, i)
                                          }
                                          options={this.state.insuranceUsers}
                                        />
                                      </div>
                                    </div>
                                    <div className="productcat-select">
                                      <Button
                                        disabled={
                                          s.checked == true ? false : true
                                        }
                                        style={{ marginTop: 4 }}
                                        onClick={() => this.onNOCallAdd_test(i)}
                                      >
                                        Add
                                      </Button>
                                      <div className="pct_flaxcontainer">
                                        {s.insurance_key_value.length > 0 &&
                                          s.insurance_key_value.map((x, y) => (
                                            <div className="productcat_callcontainer">
                                              <FormControl
                                                name="address_line_1"
                                                value={x.address_line_1}
                                                onChange={(e) =>
                                                  this.handleInputChangeAddresslist1(
                                                    e,
                                                    i,
                                                    y
                                                  )
                                                }
                                                placeholder="Key"
                                                type="text"
                                                style={{ width: "98%" }}
                                              />
                                              {this.state.address_line_1Error}
                                              <FormControl
                                                name="address_line_2"
                                                value={x.address_line_2}
                                                onChange={(e) =>
                                                  this.handleInputChangeAddresslist2(
                                                    e,
                                                    i,
                                                    y
                                                  )
                                                }
                                                placeholder="Value"
                                                type="text"
                                                style={{ width: "98%" }}
                                              />
                                              <Button
                                                onClick={() =>
                                                  this.onInsuranceRemove(i, y)
                                                }
                                              >
                                                x
                                              </Button>
                                            </div>
                                          ))}
                                      </div>
                                    </div>
                                    <br />
                                  </>
                                ) : s.label == "PCM" ? (
                                  <>
                                    <Checkbox
                                      number={s.id}
                                      key={i}
                                      checked={s.checked}
                                      onChange={(e) =>
                                        this.handleAllChecked(e, i)
                                      }
                                      label={s.label}
                                      value={s.chk_value}
                                    />
                                    <div className="productcat-select">
                                      <div className="productcat_callcontainer">
                                        <select
                                          disabled={!s.checked}
                                          className="form-control"
                                          name="tier-select"
                                          onChange={this.onChange_tier}
                                        >
                                          <option value="">
                                            SELECT TIERS{" "}
                                          </option>
                                          <option value="platinum">
                                            Platinum
                                          </option>
                                          <option value="gold">Gold</option>
                                          <option value="silver">Silver</option>
                                          <option value="browns">Browns</option>
                                        </select>
                                        <select
                                          disabled={!s.checked}
                                          className="form-control"
                                          name="tier-select"
                                          onChange={this.onChange_tags}
                                        >
                                          <option value="">SELECT TAGS</option>
                                          {this.state.tagListOption[
                                            this.state.tiers
                                          ] &&
                                            this.state.tagListOption[
                                              this.state.tiers
                                            ].map((option, index) => (
                                              <option
                                                key={index}
                                                value={option.value}
                                              >
                                                {option.label}
                                              </option>
                                            ))}
                                        </select>
                                        <select
                                          disabled={!s.checked}
                                          className="form-control"
                                          name="tier-select"
                                          onChange={this.onChange_coupons}
                                        >
                                          <option value="">
                                            SELECT COUPONS{" "}
                                          </option>
                                          {this.state.couponList.map(
                                            (option, index) => (
                                              <option
                                                key={index}
                                                value={option.id}
                                              >
                                                {option.title}
                                              </option>
                                            )
                                          )}
                                        </select>
                                      </div>
                                    </div>

                                    <div
                                      style={{ display: "flex", gap: "8px" }}
                                    >
                                      {s.value.map((item, indexs) => (
                                        <div
                                          style={{
                                            backgroundColor: "black",
                                            display: "flex",
                                            alignItems: "center",
                                            position: "relative",
                                            gap: "5px",
                                          }}
                                        >
                                          <span
                                            style={{
                                              color: "white",
                                              padding: "8px 0px 8px 16px",
                                            }}
                                            key={indexs}
                                          >
                                            {item.title}
                                          </span>

                                          <img
                                            onClick={() =>
                                              this.onRemove_coupon(i, indexs)
                                            }
                                            style={{
                                              padding: "5px",
                                              background: "transparent",
                                              cursor: "pointer",
                                              width: "20px",
                                              alignSelf: "flex-start",
                                            }}
                                            src="https://img.icons8.com/ios-glyphs/30/FFFFFF/delete-sign.png"
                                            alt="remove"
                                          />
                                        </div>
                                      ))}
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <Checkbox
                                      number={s.id}
                                      key={i}
                                      checked={s.checked}
                                      onChange={(e) =>
                                        this.handleAllChecked(e, i)
                                      }
                                      label={s.label}
                                      value={s.chk_value}
                                    />
                                    <FormControl
                                      disabled={
                                        s.checked == true ? false : true
                                      }
                                      value={s.input_value}
                                      placeholder={s.placeholder}
                                      name={s.name}
                                      type="text"
                                      onChange={(e) => this.onChange(e, i)}
                                    />
                                  </>
                                )}
                              </React.Fragment>
                            ))}
                          </div>
                        </FormGroup>
                        {this.state.feature_chkError}
                      </Col>
                    </Row>
                    <Button
                      disabled={!this.state.processing}
                      onClick={this.onSubmit.bind(this)}
                      className="btn-color" //bsStyle="info"
                      fill
                    >
                      Submit
                    </Button>
                  </form>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default editProductCatalogue;
